import React from 'react';
import { Badge, Tooltip, HStack, Icon } from '@chakra-ui/react';
import { FiRefreshCw, FiLink, FiAlertCircle, FiCheckCircle } from 'react-icons/fi';

const STATUS_CONFIG = {
  synced: { label: 'Synced', colorScheme: 'green', icon: FiCheckCircle },
  stale: { label: 'Stale', colorScheme: 'yellow', icon: FiRefreshCw },
  unlinked: { label: 'Not Linked', colorScheme: 'gray', icon: FiLink },
  error: { label: 'Sync Error', colorScheme: 'red', icon: FiAlertCircle },
  none: { label: '', colorScheme: 'gray', icon: null },
};

export default function AriveSyncBadge({ syncStatus, size = 'sm', showLabel = true, lastCheckedAt = null }) {
  const config = STATUS_CONFIG[syncStatus] || STATUS_CONFIG.none;
  if (syncStatus === 'none' || !config.icon) return null;

  const tooltip = lastCheckedAt
    ? `Arive: ${config.label} — last checked ${new Date(lastCheckedAt).toLocaleString()}`
    : `Arive: ${config.label}`;

  return (
    <Tooltip label={tooltip} fontSize="xs">
      <Badge colorScheme={config.colorScheme} fontSize={size === 'sm' ? '10px' : 'xs'} px={2} py={0.5} borderRadius="md">
        <HStack spacing={1}>
          <Icon as={config.icon} boxSize={3} />
          {showLabel && <span>{config.label}</span>}
        </HStack>
      </Badge>
    </Tooltip>
  );
}
